// =============================
// Imports
// =============================

import { memo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { Wrapper, Message, Date } from './styles';

// =============================
// Component
// =============================

const Notification = memo(({ date, fullWidth, message, seen }) => (
  <Wrapper fullWidth={fullWidth} seen={seen}>
    <Message>{message}</Message>
    {date && <Date>{dayjs().to(dayjs(date))}</Date>}
  </Wrapper>
));

Notification.displayName = 'Notification';

Notification.propTypes = {
  date: PropTypes.string,
  fullWidth: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  seen: PropTypes.bool,
};

Notification.defaultProps = {
  fullWidth: false,
  message: '',
  date: '',
  seen: false,
};

export default Notification;
